import React from 'react';
import Navigation from '../components/Navigation';
import SnowflakesEffect from '../components/SnowflakesEffect';
import { isChristmasPeriod } from '../utils/christmasTheme';
import '../styles/ContactPage.css';
import '../styles/christmas.css';

const ContactPage: React.FC = () => {
  const isChristmas = isChristmasPeriod();
  
  return (
    <div className={`contact-page ${isChristmas ? 'christmas' : ''}`}>
      {isChristmas && <SnowflakesEffect />}
      {isChristmas && <div className="christmas-overlay" />}
      <Navigation />
      <div className="page-content">
        <div className="content-container">
          <h1 className="page-title">Contact Us</h1>
          <div className="contact-section">
            <p className="contact-intro">
              Have questions, feedback, or just want to say hi? We'd love to hear from you!
            </p>
            
            <div className="contact-methods">
              <div className="contact-method">
                <h2 className="method-title">📧 Email</h2>
                <p className="method-details">
                  <a href="mailto:hello@thanksbeer.com">hello@thanksbeer.com</a>
                </p>
              </div>
              
              <div className="contact-method">
                <h2 className="method-title">💬 Feedback</h2>
                <p className="method-details">
                  We're always looking to improve ThanksBeer. If you have suggestions 
                  or feature requests, please reach out!
                </p>
              </div>
              
              <div className="contact-method">
                <h2 className="method-title">🐛 Report a Bug</h2>
                <p className="method-details">
                  Found something not working quite right? Let us know and we'll fix it 
                  as soon as possible.
                </p>
              </div>
              
              <div className="contact-method">
                <h2 className="method-title">🤝 Partnership</h2>
                <p className="method-details">
                  Interested in partnering with ThanksBeer? We're open to collaborations 
                  that help spread more cheer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
